var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.sample),function(word,wordIndex){return _c('span',{key:wordIndex},[_c('HighlightedBlock',{attrs:{"token":word.word,"sampleLabel":word.label,"isPerturbed":word.isPerturbed,"showLabel":true}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }